import React, { memo } from 'react';

import { EHashLinks } from '@enum';

import { useSetActiveClass, useThemeGetter } from '@hooks';

import { NavLinksContainer, OneLink } from './NavLinks.styled';

import { NavLinksProps } from './NavLinks.types';

export const NavLinks = memo(({ scrollToSection }: NavLinksProps) => {
  const activeClass = useSetActiveClass();
  const {
    theme: { Main, Secondary, Highlight },
  } = useThemeGetter();

  return (
    <NavLinksContainer>
      {Object.values(EHashLinks).map((one) => (
        <OneLink
          key={one}
          onClick={() => scrollToSection(one)}
          className={activeClass(one)}
          main={Main}
          secondary={Secondary}
          highlight={Highlight}
        >
          {one}
        </OneLink>
      ))}
    </NavLinksContainer>
  );
});
